module.exports = "/fonts/Simple-Line-Icons.svg?2fe2efe63441d830b1acd106c1fe8734";